/** The frame keeps its size whether or not a logo is showing, so the greeting
 *  and review card below it do not shift when the logo arrives. Until the
 *  merchant's logo has loaded the frame is deliberately empty — no spinner and
 *  no POS logo standing in for the shop's own branding. */
export default function ShopLogo({ src }: { src: string | null }) {
  return (
    <div className="relative mb-[clamp(10px,1.5vh,22px)] flex h-[clamp(180px,26vw,300px)] w-[clamp(180px,26vw,300px)] shrink-0 items-center justify-center">
      {src && <img src={src} alt="Shop Logo" className="block h-[85%] w-[85%] object-contain" />}
    </div>
  )
}
